import { useQuery } from "@tanstack/react-query";
import { activityApi } from "@/lib/api/crm";

export const DEAL_ACTIVITY_KEY = "deal-activity";

export function useDealActivity(dealId: string) {
  return useQuery({
    queryKey: [DEAL_ACTIVITY_KEY, dealId],
    queryFn: () => activityApi.getDealActivity(dealId),
    enabled: !!dealId,
  });
}
